import { OrderType } from 'types';

export interface ClientOrderToPayView {
	id: number;
	type: OrderType;
	address: string;
	grossPrice: number;
	deliveryDate: string;
	alreadyPaid: number;
}
